'use client';

import type { ReactNode, TransitionStartFunction } from 'react';
import { createContext, useMemo, useTransition } from 'react';

export const PageTransitionProviderContext = createContext<{
  start: TransitionStartFunction;
} | null>(null);

export const PageLoadingProviderContext = createContext<{
  loading: boolean;
}>({ loading: false });

export const PageTransitionProvider = ({ children }: { children: ReactNode }) => {
  const [loading, start] = useTransition();

  return (
    <PageTransitionProviderContext.Provider value={useMemo(() => ({ start }), [])}>
      <PageLoadingProviderContext.Provider value={useMemo(() => ({ loading }), [loading])}>
        {children}
      </PageLoadingProviderContext.Provider>
    </PageTransitionProviderContext.Provider>
  );
};
